<div class="w-full bg-card dark:bg-transparent py-12 md:py-16 px-4 md:px-12 lg:px-24 print:hidden">
    <div class="max-w-screen-xl mx-auto">
        <div class="flex flex-col md:flex-row items-center md:items-start md:justify-between">
            <!-- Logo Section -->
            <div class="flex flex-col items-center md:items-start mb-8 md:mb-0 w-full md:w-auto md:max-w-xs text-center md:text-left">
                <div class="mb-4">
                    <img class="h-8 md:h-10 dark:hidden" src="assets/images/logo/verified-text.svg" alt="Logo" />
                    <img class="h-8 md:h-10 hidden dark:block" src="assets/images/logo/verified-text.svg" alt="Logo" />
                </div>
                <span class="text-sm text-secondary font-medium leading-relaxed">
                    {{ config?.footerDescription | transloco }}
                </span>
            </div>

            <!-- Navigation Columns -->
            <div class="flex flex-row flex-wrap justify-center md:justify-end gap-x-12 md:gap-x-24 gap-y-8 mb-8 md:mb-0">
                <ng-container *ngFor="let group of footerNavigation">
                    <!-- Group with children -->
                    <div *ngIf="group.children && group.children.length > 0" class="flex flex-col space-y-4">
                        <h4 class="text-xs font-bold text-secondary uppercase tracking-widest opacity-60">
                            {{ group.title | transloco }}
                        </h4>
                        <ul class="flex flex-col space-y-3">
                            <li *ngFor="let child of group.children">
                                <a *ngIf="child.externalLink" [href]="child.link" [target]="child.target || '_self'"
                                    class="text-sm font-medium text-secondary hover:text-primary transition-colors duration-200">
                                    {{ child.title | transloco }}
                                </a>
                                <a *ngIf="!child.externalLink" [routerLink]="child.link"
                                    class="text-sm font-medium text-secondary hover:text-primary transition-colors duration-200">
                                    {{ child.title | transloco }}
                                </a>
                            </li>
                        </ul>
                    </div>
                    <!-- Basic item without children -->
                    <div *ngIf="!group.children || group.children.length === 0" class="flex flex-col">
                        <a [routerLink]="group.link"
                            class="text-sm font-bold text-secondary hover:text-primary transition-colors duration-200 uppercase tracking-widest opacity-60">
                            {{ group.title | transloco }}
                        </a>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Bottom Section - Copyright and Social Icons -->
        <div class="flex flex-col-reverse md:flex-row items-center justify-between pt-8 border-t gap-6">
            <!-- Copyright -->
            <div class="text-sm text-secondary font-medium text-center md:text-left" [innerHTML]="copyrightText">
            </div>

            <!-- Social Icons -->
            <div class="flex items-center space-x-6">
                <ng-container *ngFor="let item of socialNavigation">
                    <a [href]="item.link" target="_blank"
                        class="text-secondary/40 hover:text-primary transition-colors duration-200">
                        <mat-icon class="icon-size-5" [svgIcon]="item.icon"></mat-icon>
                    </a>
                </ng-container>
            </div>
        </div>
    </div>
</div>